export default {"src":"/_next/static/media/valuePlanBackground.084189a8.svg","height":94,"width":328,"blurWidth":0,"blurHeight":0};